<template>
  <div class="relative">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />

        <vs-spacer />

        <search-bar class="mr-2" v-if="this.initialRole === 'admin'"/>

        <change-theme class="mr-0" />

        <menu-type-layout class="mr-2" :navbarColor="navbarColor" v-if="windowWidth >= 1200 && this.initialRole === 'admin'" />

        <notification-drop-down />

        <profile-drop-down />

      </vs-navbar>
    </div>
  </div>
</template>


<script>
import MenuTypeLayout       from './components/MenuTypeLayout.vue'
import SearchBar            from './components/SearchBar.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'
import ChangeTheme          from './components/ChangeTheme.vue'

export default {
  name: 'the-navbar-vertical',
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  data () {
    return {
      initialRole: 'public'
    }
  },
  components: {
    MenuTypeLayout,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown, 
    ChangeTheme
  },
  computed: {
    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#2B2B2B' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {'text-white': (this.navbarColor !== '#2B2B2B' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj () {
      if      (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth)               return 'navbar-full'
    }
  },
  methods: {
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    }
  }, 
  created () {
    this.initialRole = 'public'
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))
    if (userRoles && userRoles.some(item => item.id_role < 40)) this.initialRole = 'admin'
  }
}
</script>

